import { Card, Skeleton, Typography } from "antd";
import React from "react";

const { Title } = Typography;
export default function StoreOverview({ storeOverview }) {
	return (
		<Card style={{height:'100%'}}>
			<Title level={4}>🛍️ Store Overview</Title>
			{storeOverview ? (
				<React.Fragment>
					<p>
						Total Products: <strong>{storeOverview?.totalProduct}</strong>
					</p>
					<p>
						Updated: <strong>{storeOverview?.updatedProduct}</strong>
					</p>
					<p>
						Pending: <strong>{storeOverview?.pendingUpdate>0?storeOverview?.pendingUpdate:0}</strong>
					</p>
				</React.Fragment>
			) : (
				<Skeleton active paragraph={{ rows: 2 }} />
			)}
		</Card>
	);
}
